import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-comments-section',
    templateUrl: './comments-section.component.html',
    styleUrls: ['./comments-section.component.css']
})
export class CommentsSectionComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
